const cancel = '取消'
const save = '保存'

export default {

  global: {
    generalError: '很抱歉！无法处理该请求。请重新加载页面。',
    signature: '谨致问候！',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: '添加简历或其他要求提供的附件',
      placeholderWithDescription: '添加所要求的附件',
      remove: '删除',
      allowedFileTypes: '允许使用的文件类型',
      errors: {
        size: '您的文件太大，文件最大为5MB。',
        empty: '文件不包含数据',
        invalidType: fileType => `很抱歉，出于安全原因，${fileType}文件不允许使用`,
        typeNotWhitelisted: '很抱歉，不允许使用此文件类型。',
      },
    },

    agreeTos: {
      privacyLinkText: '隐私政策',
      termsLinkText: '条款和条件',
      privacyPolicyText: '我们高度重视您的隐私。请先阅读我们的 ',
      termsText1: '请先阅读并接受',
      termsText2: '之后再向我们提供您的个人资料。',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `如果您不希望我们处理您的个人资料，您可以通过${mail}向我们发送电子邮件，要求删除您的资料。`,
      customSupportPrivacyInfo: link => `如果您不希望我们处理您的个人数据，请联系 ${link}，向我们提出清除个人数据的要求。`,
    },

    buttons: {
      close: '关闭',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: '删除',
      confirm: '再试一次',
    },

    confirmButton: {
      wait: count => `等待${count}`,
      confirm: '确认',
    },

    controlStatus: {
      text: {
        empty: '填写',
        valid: () => '准备就绪',
      },
      textarea: {
        empty: '填写',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: '设置',
        valid: () => '准备就绪',
      },
      file: {
        empty: '选择',
        valid: () => '更改',
      },
      list: {
        empty: '添加',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: '搜索',
        valid: () => '准备就绪',
      },
    },

    cookieConsentModal: {
      title: '本网站使用 Cookie',
      body: '接受所有 Cookie 即表示您同意在您的设备上存储 Cookie，以增强本网站的导航功能、分析本网站的使用情况并协助我们的营销工作。',
      learnMoreLinkText: '了解更多关于我们如何使用 Cookie 的信息',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: '管理 Cookie',
      acceptAll: '接受所有 Cookie',
      manageTitle: '管理同意首选项',
      necessaryCookiesTitle: '必要的 Cookie',
      necessaryCookiesBody:
        '必要的 Cookie 是指本网站运行所必需的、无法在我们的系统中关闭的 Cookie。',
      performanceCookiesTitle: '性能 Cookie',
      performanceCookiesBody:
        '性能 Cookie 可以让我们统计访问量和流量源，从而衡量和改进我们网站的性能。',
      confirmChoices: '确认我的选择',
      marketingCookiesTitle: '营销 Cookie',
      marketingCookiesBody:
        '营销 Cookie 能帮助我们实现广告的个性化推送，衡量广告效果。',
      functionalCookiesTitle: '功能 Cookie',
      functionalCookiesBody:
        '功能 Cookie 用于增强网站的功能。如果没有这些 Cookie，部分功能可能会无法使用。如网络交谈服务和用户偏好设置等均属于功能 Cookie。',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: '删除',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: '禁止',
      content: '我们的服务器有礼貌地（但坚定地）拒绝您的浏览器所作出的请求。请注意，Recright必须在同一时间内在单一设备/浏览器上使用。',
      link: '首页',
    },

    error404: {
      heading: '什么也没找到',
      content: '我们尽力了，但是，我找不到您所请求地址。您可能输入了一个过期的链接或意外输入了错误的地址。',
      link: '首页',
    },

    error410: {
      heading: '关闭',
      content: '无法显示，该岗位可能已被关闭或申请期限已结束。',
      link: '首页',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: '正在初始化',
      connection_error_hint: '无法建立网络连接，\n请尝试重新加载该页面。',
      permission_hint: '您需要允许本网站使用您的网络摄像头和麦克风。',
      searching_camera_hint: '正在搜索网络摄像头…',
      camera_reserved_hint: '其他应用程序或网页已占用您的网络摄像头。\n请关闭该应用程序，然后重新加载本页面。',
      camera_reserved_hint_chrome_extra: '尊敬的Chrome用户，你需要允许Recright在以下地址栏的对话中使用网络摄像头。',
      no_camera_hint: '无法找到网络摄像头。',
      no_mic_hint: '无法找到麦克风。',
      uploading_text: '正在上传…',
      rtmpt_in_use: '如果您的网络管理员允许RTMP，则无需此步骤。\n询问我们具体方法。',
      preview_text: '网络摄像头正处于预览模式',
      close_text: '关闭摄像头',
      remove_text: '删除花费时间：',
      noflash_errortext_install: link => `您似乎尚未安装Adobe Flash Player，您需要flash插件来录制视频。在此获取flash插件：${link}`,
      noflash_errortext_enable: link => `如果您已安装flash插件，但此消息依然显示。请查阅此处：${link}`,
      noflash_errortext_differentbrowser: '或者，您可以尝试使用支持HTML5录制的浏览器。我们建议使用Chrome或Firefox。',
    },

    footer: {
      terms: '条款',
      license: 'General Terms of Service',
      privacyPolicy: '《隐私政策》',
      customSupport: link => `联系 ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: '您会如何给此次面试体验打分？',
      howWouldYouRateJobAd: '您为此次申请体验如何打分？',
      yourResponseIsAnonymous: '您所回答的内容将作匿名处理。',
      thankYouFeedback: '感谢您的反馈！',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: '很抱歉，不允许使用此文件类型。',
      isRequired: '此字段为必填字段。',
      isEmail: value => `${value}不是有效电子邮件。`,
      isDate: value => `${value}不是有效的日期。`,
      invalidUrl: '该URL无效。',
      singleHireEndError: '单次招聘不可超过60天。',
      isNotTooOldForLive: '日期为过去的日期。',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: '姓名',
      city: '家乡',
      email: '电子邮箱',
      phone: '电话',
      applyForPosition: '申请职位',
      back: '返回',
      continue: '继续',
      submit: '提交',
      saveForLater: '稍候继续',
      namePlaceholder: '请输入您的姓名',
      emailPlaceholder: '请输入您的电子邮件地址',
      phonePlaceholder: '请输入您的电话号码',
      cityPlaceholder: '请输入您当前城市',
      links: '添加链接，例如，您的LinkedIn个人资料页面、个人网站等',
      legendBasicInfo: '基本资料',
      legendLinks: '链接',
      legendAttachments: '附件',
      legendAdditionalFields: '额外资料',
      coverLetter: '求职信',
      attachments: '附件',
      introduction: '请在此写下您的求职信',
      thankYou: '谢谢！',
      luck: '祝您好运！',
      close: '关闭',
      required: '*星号标记的项目为必填项目。',
    },

    jobAdContainer: {
      endTime: date => (date ? `开放截止时间：${date}` : ''),
    },

    jobAdDetails: {
      apply: '申请工作',
    },

    jobAdQuickInterview: {
      title: '开始您的视频面试',
      back: '返回',
      submit: '提交',
      saveForLater: '稍候继续',
      description: '为了让招聘人员了解您更多信息，我们邀请您录制简短的视频回答。在您的回答中，请表达您的个性。',
      requiredNote: '请注意，这是申请流程的一部分；您可以进行多次录制回答，只有在您提交申请之后，招聘人员才能看到您的申请。',
      reminderNote: '您可以立即录制回答，或者您可以点击稍后继续按钮。我们将保存您的申请并发送您的申请链接到您的电子邮箱，稍候请点击申请链接继续您的申请。',
    },

    jobAdRow: {
      responses: '申请',
      status: {
        open: '打开',
        filled: '已填写',
        cancelled: '已取消',
        done: '完成',
        close: '关闭',
        draft: '已关闭（草稿）',
        hidden: '隐藏',
      },
    },

    interviewRow: {
      responses: '候选人',
    },

    linkedInProfile: {
      showLinkedInProfileModal: '显示LinkedIn个人资料',
    },

    linkedInButton: {
      error: '获取个人资料时出错，请重试。',
      buttonText: '通过 LinkedIn 申请',
    },

    linkedInContainer: {
      linkedInButtonDescription: '您可以使用LinkedIn个人资料预填充申请表格',
      linkedInOr: '或者',
      error: '获取个人资料时出错，请重试。',
    },

    linkListInput: {
      addField: '添加',
      removeField: '删除',
      invalidUrl: '该URL无效。',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        timeIn: partName => `Time in ${partName}:`,
        totalTime: 'Total time in interview:',
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: '正在加载…',
      saving: '正在保存…',
      sending: '正在发送…',
    },

    modalApplicationForm: {
      applyForPosition: '申请职位',
      continue: '继续',
      name: '请输入您的姓名',
      email: '请输入您的电子邮件地址',
      phoneNumber: '请输入您的电话号码',
      links: '您可以输入链接',
      legendLinks: '链接',
      legendAttachments: '附件',
      coverLetter: '求职信',
      attachments: '附件',
      introduction: '请在此编辑您的简介',
      thankYou: '谢谢！',
      luck: '祝您好运！',
      close: '关闭',
    },

    modalConfirm: {
      cancel,
      confirm: '确定',
    },

    modalAlert: {
      close: '关闭',
    },

    modalLinkShare: {
      title: '可分享的公共链接',
      info: '您可以使用该公共链接分享该职位广告。\n任何对此职位感兴趣的人都可以看到该工作广告\n然后决定是否申请。\n在接收到申请时，您将收到申请的通知。\n\n这是该工作广告的公共链接：',
    },

    modalVideoAdd: {
      title: '添加新的视频',
      chooseTitle: '添加新的视频',
      titlePlaceholder: '请在此输入视频标题',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: '请上传一个新的视频',
      info: '允许的最大视频大小为500MB。我们建议在上传之前对视频进行压缩，这样的话，上传和转换所花费时间更少。',
    },

    modalCandidateInfo: [
      {
        headline: '录制您的视频回复，',
        content: '您可以根据自己意愿多次录制。视频在录制之后将自动保存，如果您对当前录制的视频不满意请点击右上角"取消"并重新录制。您可以点击最下方"稍后继续"按钮稍后录制您的回答，我们将发送稍后继续申请的链接至您的邮箱。',
        mobileContent: '您可以根据自己意愿多次录制。您将会看到视频加载以及被保存的状态。您可以点击最下方"稍后继续"按钮稍后录制您的回答，我们将发送稍后继续申请的链接至您的邮箱。<br><br><strong>如果您的视频窗口一直显示黑屏，并且，您使用苹果移动设备，您可以<a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">在此</a></strong>找到如何解决该问题的说明。',
      },
      {
        headline: '在录制视频回复之后，',
        content: '请确保视频可正常播放，并可以清楚听到您的声音。如果您对当前视频回复满意，请点击"提交回复"，请注意提交之后您的回答将被锁定，您将无法再次对其进行编辑。',
      },
      {
        headline: '在您完成所有视频回复之后，',
        content: '请点按“提交回答并完成面试”按钮。此后，您的申请将发送给招聘者，您将无法再返回该视频面试。',
      },
      {
        headline: '如果您需要帮助，',
        content: mailto => `请点按页面右侧的“帮助”按钮，或者通过${mailto}向我们发送电子邮件。`,
        customContent: link => `联系 ${link}`,
      },
    ],

    navigationBar: {
      back: '返回',
      dashboard: '主页面',
      frontpage: '首页',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `电话格式 ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: '平均分',
      reset: '重置',
    },

    share: {
      share: '分享到',
      copy: '拷贝链接',
    },

    sort: {
      sort: '分类排序',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: '已选择',
      change: '添加',
    },

    video: {
      videoNotFound: '视频正在处理中或无法找到视频',
      retry: '请再试一次',
      originalLanguageLabel: '原文',
      englishLanguageLabel: '英语',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? '上传或录制新视频' : '选择文件'),
      videoPlaceholder: '录制您的回复',
      uploadPlaceholderCandidate: '上传视频',
      submit: '提交回复',
      notAnswered: '您尚未回答',
      remove: '删除',
      converting: '正在转换视频。请稍候…',
      uploading: '正在上传视频。请稍候…',
      error: {
        invalid: '所选择的文件太大，请选择其他文件。',
        upload: '很抱歉，我们无法上传该视频，请稍候再试。',
        transcode: '所选择的视频已损坏或无效，请稍候再试。',
      },
    },

    virtualBg: {
      showMoreButtonText: '展开',
      showLessButtonText: '收起',
      infoText1:
        '录制过程中，始终保持标签在前台激活状态。录制期间请勿使用其他应用程序。',
      infoText2:
        '视频背景视频在最新版本的浏览器上以及相对较新和 性能强大的设备上效果最佳。',
      infoText3: '请确保其他应用程序没有占用麦克风或 摄像头。',
    },

    videoResponse: {
      videoPlaceholder: '录制您的视频回复',
      uploadPlaceholder: '上传视频',
      submit: '提交回复',
      notAnswered: '您尚未回答',
      required: '此问题需要回答',
      startInterview: '开始面试',
    },

    webcam: {
      useVideoBgButtonText: '使用视频背景',
      removeVideoBgButtonText: '删除视频背景',
      starting: '正在启动…',
      close: '关闭摄像头',
      remove: '取消',
      record: '录制',
      stop: '停止',
      retake: '重新开始',
      submit: '提交回复',
      converting: '正在转换视频。请稍候…',
      uploading: '正在上传视频。请稍候…',
      downloading: '正在下载视频。请稍候…',
      processing: '正在处理…',
      uploadInProgress: '视频传输中，请勿关闭浏览器或更改页面。',
      uploaded: '视频已上传。',
      error: {
        DevicesNotFoundError: '无法使用摄像头或麦克风，请检查是否已启用。',
        NotFoundError: '无法使用摄像头或麦克风，请检查是否已启用。',
        NotAllowedError: '您尚未授予许可使用该摄像头或麦克风。',
        PermissionDismissedError: '您取消了许可，请允许使用摄像头和麦克风。',
        PermissionDeniedError: '您已拒绝对摄像头或麦克风的访问。',
        NotReadableError: '无法读取摄像头或麦克风数据流，可能存在硬件问题。',
        SecurityError: '由于存在安全错误，无法使用摄像头或麦克风',
        stream: '发生错误，请重新启动您的浏览器。如果问题依然无法解决，请尝试使用不同的浏览器。',
        download: '视频下载失败，再试一次？',
        upload: '视频上传失败，再试一次？',
        emptyBlob: '您的浏览器或设备内存已满，因此无法进行录制，请刷新页面。如果无法解决问题，请重新启动浏览器。如果依然无法解决问题，请尝试使用其他浏览器。',
        alternativeRecorder: '点击此处，也可以上传文件。',
        reconnecting: '连接中断。正在尝试重新连接。',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `您好！我们想邀请您参加一场题为 ${title} 的视频面试！此邀请也已发送至您的电子邮箱。`,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
